import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { useTheme } from '@zenbusiness/zui/styles';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';

export default function Logo() {
  const theme = useTheme();
  const { sizes } = useBreakpoints();

  return (
    <SharedAsset
      alt="ZenBusiness Inc."
      color={theme.palette.fixed.white}
      height={sizes.isMobile ? 18 : 20}
      src="/logo/new-zen-logo.svg"
    />
  );
}
